import axios from 'axios';

const api = axios.create({
  baseURL: '/api/admin',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      const isLoginPage = window.location.pathname === '/login';
      if (!isLoginPage) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// 用户反馈 API（管理后台使用 /api/feedback 路径，不使用 /api/admin 前缀）
const feedbackApiClient = axios.create({
  baseURL: '/api/feedback',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

feedbackApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

feedbackApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      const isLoginPage = window.location.pathname === '/login';
      if (!isLoginPage) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const userFeedbackApi = {
  // 获取所有反馈列表
  getAdminFeedbacks: (params?: { page?: number; pageSize?: number; status?: string; feedbackType?: string; user?: string; title?: string }) =>
    feedbackApiClient.get('/admin/list', { params }),

  // 审核反馈
  reviewFeedback: (id: number, data: { status: 'approved' | 'rejected'; adminReply?: string; rewardCredits?: number }) =>
    feedbackApiClient.post(`/admin/${id}/review`, data),

  // 获取反馈详情
  getAdminFeedbackDetail: (id: number) =>
    feedbackApiClient.get(`/admin/${id}`),
};

// 任务配置 API
export const taskConfigApi = {
  // 获取任务配置列表
  getTaskConfigs: () =>
    api.get('/task-config'),
};

export default api;
